
export default function HeroCard4() {
    const ICONS = {
    center: "https://cdn-icons-png.flaticon.com/512/5968/5968853.png",
    calendar: "https://cdn-icons-png.flaticon.com/512/747/747310.png",
    whatsapp: "https://cdn-icons-png.flaticon.com/512/733/733585.png",
    payments: "https://cdn-icons-png.flaticon.com/512/891/891462.png",
    zoom: "https://cdn-icons-png.flaticon.com/512/732/732200.png",
    zapier: "https://cdn-icons-png.flaticon.com/512/5968/5968988.png",
    wix: "https://cdn-icons-png.flaticon.com/512/5968/5968705.png",
    dev: "https://cdn-icons-png.flaticon.com/512/9068/9068641.png",
    circle: "https://cdn-icons-png.flaticon.com/512/1827/1827504.png",
  };
  return (<>
      <section className="le-hero">

      {/* Floating shape-c4s */}
      <div className="float-c4-shape-c4 fs1"></div>
      <div className="float-c4-shape-c4 fs2"></div>
      <div className="float-c4-shape-c4 fs3"></div>

      <div className="le-container">

        {/* GLASS CARD WRAPPER */}
        <div className="le-glass-card">

          {/* LEFT CONTENT */}
          <div className="le-left">
            <h1 className="le-title">
              Change is the<br />
              end result of all<br />
              true <span className="le-highlight">Learning</span>
            </h1>

            <p className="le-sub">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Nullam egestas eget libero a gravida.
            </p>

            <div className="le-btn-row">
              <button className="le-btn green">Book Online</button>
              <button className="le-btn text">Watch Video</button>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="le-right">
            <div className="le-image-box">

              {/* gradient glow */}
              <div className="le-glow"></div>

              {/* Animated doodle-c4s */}
              <img
                src={ICONS?.zoom}
                className="le-doodle-c4 d1-c4"
                alt=""
              />
              <img
                src={ICONS?.center}
                className="le-doodle-c4 d2-c4"
                alt=""
              />

              <img
                src="https://images.unsplash.com/photo-1588072432836-e10032774350?q=80&w=800"
                alt="Teacher"
                className="le-hero-img"
              />

              {/* CUTOUT SHAPES */}
              <div className="shape-c4 s1"></div>
              <div className="shape-c4 s2"></div>
              <div className="shape-c4 s3"></div>
            </div>
          </div>

        </div>
      </div>

      {/* Decorative Wave Bottom */}
      <div className="le-wave">
        <svg viewBox="0 0 1440 319">
          <path
            fill="#ffffff"
            d="M0,256L48,234.7C96,213,192,171,288,170.7C384,171,480,213,576,234.7C672,256,768,256,864,245.3C960,235,1056,213,1152,186.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>
    </section>
    <style>{`/* ---------- HERO SECTION ---------- */
.le-hero {
  width: 100%;
  background: #fef8f4;
  padding: 80px 0 160px;
  position: relative;
 
}

/* ---------- FLOATING SHAPES ---------- */
.float-c4-shape-c4 {
  position: absolute;
  background: rgba(255, 190, 150, 0.25);
  border-radius: 20px;
  z-index: 1;
  animation: float-c4 6s ease-in-out infinite alternate;
}

.fs1 {
  width: 60px;
  height: 60px;
  top: 120px;
  left: 80px;
  animation-duration: 7s;
}

.fs2 {
  width: 40px;
  height: 40px;
  top: 220px;
  right: 120px;
  animation-duration: 6s;
}

.fs3 {
  width: 30px;
  height: 30px;
  bottom: 260px;
  left: 48%;
  background: rgba(140, 220, 200, 0.25);
  animation-duration: 8s;
}

/* float-c4ing animation keyframes */
@keyframes float-c4 {
  0% { transform: translateY(0) translateX(0); }
  100% { transform: translateY(-22px) translateX(14px); }
}

/* ---------- MAIN CONTAINER ---------- */
.le-container {
  width: 100%;
  max-width: 1300px;
  
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  position: relative;
  z-index: 10;
}

/* ---------- LEFT SIDE ---------- */
.le-left { flex: 1; }

.le-title {
  font-size: 50px;
  line-height: 1.15;
  font-weight: 800;
  color: #222;
}

.le-highlight {
  color: #2ab972;
}

.le-sub {
  margin-top: 20px;
  font-size: 18px;
  width: 80%;
  color: #666;
}

.le-btn-row {
  margin-top: 30px;
  display: flex;
  gap: 20px;
}

.le-btn {
  padding: 14px 32px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.le-btn.green { background: #2ab972; color: white; }
.le-btn.text { background: transparent; color: #111; }

/* ---------- RIGHT SIDE ---------- */
.le-right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.le-image-box {
  position: relative;
  width: 380px;
  height: 420px;
}

/* gradient glow */
.le-glow {
  position: absolute;
  width: 140%;
  height: 140%;
  left: -20%;
  top: -20%;
  background: radial-gradient(
    circle at 60% 40%,
    rgba(255, 165, 100, 0.55),
    rgba(255, 165, 100, 0.1),
    rgba(255, 165, 100, 0)
  );
  filter: blur(40px);
  z-index: 0;
  transform: scale(1.3);
}

/* hero image */
.le-hero-img {
  width: 100%;
  height: 100%;
  border-radius: 22px;
  object-fit: cover;
  position: relative;
  z-index: 5;
  box-shadow: 0 15px 40px rgba(0,0,0,0.15);
}

/* CUTOUT SHAPES */
.shape-c4 {
  position: absolute;
  background: rgba(255, 255, 255, 0.51);
  border-radius: 10px;
  box-shadow: 0 6px 16px rgba(0,0,0,0.06);
  z-index: 6; 
}

.s1 { width: 35%;height:110px; left: 10%; top: 60px; transform: rotate(-55deg);animation: s1Float 7s ease-in-out infinite alternate; }
.s2 { width: 20%; height:50px; left: 70%; top: 130px; transform: rotate(3deg); animation: s2Float 7s ease-in-out infinite alternate;}
.s3 { width: 25%; height:150px; left: 25%; bottom: 40px; transform: rotate(-114deg);animation: s3Float 7s ease-in-out infinite alternate; }

/* ---------- DECORATIVE SVG WAVE ---------- */
.le-wave {
  width: 100%;
  position: absolute;
  bottom: -1px;
  left: 0;
  z-index: 2;
}

.le-wave svg {
  width: 100%;
  height: auto;
  display: block;
}
.le-glass-card {
  background: rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(22px) saturate(180%);
  -webkit-backdrop-filter: blur(22px) saturate(180%);
  border-radius: 28px;
  padding: 40px;
  display: flex;
  gap: 40px;flex-wrap:wrap;
  align-items: center;
  border: 1.4px solid rgba(255, 255, 255, 0.45);
  box-shadow: 0 12px 40px rgba(0,0,0,0.08);
}
.le-doodle-c4 {
  position: absolute;
  width: 140px;
  opacity: 0.7;
  z-index: 2;
  animation: doodle-c4Float 7s ease-in-out infinite alternate;
}

.d1-c4 {
  left: -70px;
  top: 20px;
  animation-duration: 8s;
}

.d2-c4 {
  right: -50px;
  bottom: 40px;
  width: 120px;
  animation-duration: 6s;
}

@keyframes doodle-c4Float {
  0% { transform: rotate(-14deg) translateY(0px); }
  100% { transform: rotate(4deg) translateY(-14px); }
}
@keyframes s1Float {
  0% { transform: rotate(-14deg) translateY(0px); }
  100% { transform: rotate(4deg) translateY(-64px); }
}
@keyframes s2Float {
  0% { transform: rotate(14deg) translateY(0px); }
  100% { transform: rotate(4deg) translateY(-14px); }
}
@keyframes s3Float {
  0% { transform:  translateY(10px); }
  100% { transform: rotate(4deg) translateY(-14px); }
}
.le-glow {
  position: absolute;
  width: 160%;
  height: 160%;
  left: -30%;
  top: -20%;
  background: radial-gradient(
    circle at 50% 30%,
    rgba(255, 140, 80, 0.55),
    rgba(255, 140, 80, 0.08),
    rgba(255, 140, 80, 0)
  );
  filter: blur(55px);
  z-index: 0;
  animation: glowPulse 6s ease-in-out infinite alternate;
}

@keyframes glowPulse {
  0% { transform: scale(1); opacity: 0.85; }
  100% { transform: scale(1.12); opacity: 1; }
}

/* ---------- RESPONSIVE ---------- */
@media (max-width: 992px) {
  .le-container { flex-direction: column; text-align: center; }
  .le-sub { width: 100%; }
  .le-right { margin-top: 40px; }
  .le-image-box { width: 300px;  }
}

                                 /* xs */
@media (max-width: 767px) {.le-container {  text-align: center; }
  .le-sub { width: 100%; }
  .le-right { margin-top: 40px; }
  .le-image-box {  }
}
`}</style>
  </>);
}
